// extracted by mini-css-extract-plugin
export default {"empty-box":"EmptyFeedList_empty-box__7c4ya"};